import { createFileRoute } from "@tanstack/react-router";
import { type RouterOutput } from "api-client/legacy-trpc";

import { loaderHandler } from "src/lib/loaderHandler";
import { ResetPasswordPage } from "src/pages/ResetPasswordPage";
import { type TranslationKey } from "src/types";

type LoaderReturn =
  | { error: TranslationKey }
  | { resetPassword: RouterOutput["auth"]["retrievePasswordReset"] };

export const Route = createFileRoute("/_public/reset-password/$resetId")({
  component: RouteComponent,
  ssr: true,
  async loader({ params }) {
    return await loaderHandler(async ({ trpc }) => {
      let loaderData: LoaderReturn;

      if (!params.resetId) {
        loaderData = { error: "errors.RESET_PASSWORD_INVALID_LINK" };
      } else {
        const resetPassword = await trpc.auth.retrievePasswordReset.query({
          id: params.resetId,
        });

        if (!resetPassword) {
          loaderData = { error: "errors.RESET_PASSWORD_INVALID_LINK" };
        } else {
          const hasExpired = new Date(resetPassword.expiresAt) < new Date();

          if (hasExpired) {
            loaderData = { error: "errors.RESET_PASSWORD_EXPIRED_LINK" };
          } else {
            const isUsed = resetPassword.resetedAt !== null;

            if (isUsed) {
              loaderData = { error: "errors.RESET_PASSWORD_ALREADY_USED" };
            } else {
              loaderData = {
                resetPassword,
              };
            }
          }
        }
      }

      return {
        data: loaderData,
      };
    });
  },
});

function RouteComponent() {
  return <ResetPasswordPage />;
}
